import { useInView } from '@/hooks/useInView';
import { TrendingUp, Search, ShoppingCart, Globe, Smartphone, BarChart3 } from 'lucide-react';

const stats = [
  {
    icon: Search,
    value: '97%',
    label: 'der Verbraucher suchen online nach lokalen Unternehmen',
    source: 'BrightLocal, 2024',
  },
  {
    icon: ShoppingCart,
    value: '85,4 Mrd. €',
    label: 'E-Commerce-Umsatz in Deutschland (2024) – Tendenz steigend',
    source: 'HDE / Statista',
  },
  {
    icon: Globe,
    value: '75%',
    label: 'der Nutzer beurteilen die Glaubwürdigkeit eines Unternehmens anhand der Website',
    source: 'Stanford Web Credibility Research',
  },
  {
    icon: Smartphone,
    value: '61%',
    label: 'der mobilen Nutzer kontaktieren eher ein Unternehmen mit einer mobilfähigen Website',
    source: 'Google / Think with Google',
  },
  {
    icon: TrendingUp,
    value: '+120%',
    label: 'mehr Wachstum bei KMU mit professioneller Webpräsenz gegenüber ohne',
    source: 'McKinsey Digital, 2023',
  },
  {
    icon: BarChart3,
    value: '2030',
    label: 'wird der globale E-Commerce-Markt auf über 8 Billionen USD geschätzt',
    source: 'Statista Market Insights',
  },
];

export default function ErfolgsgeschichtenSection() {
  const [ref, inView] = useInView();

  return (
    <section id="erfolgsgeschichten" ref={ref} data-testid="erfolgsgeschichten-section" className="relative py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className={`text-center mb-16 transition-all duration-700 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <span className="text-xs tracking-[0.2em] uppercase font-bold text-purple-600 font-['Outfit']">Warum jetzt handeln?</span>
          <h2 className="mt-4 text-4xl sm:text-5xl font-light tracking-tight text-slate-900 font-['Outfit']">
            Die Zahlen sprechen <span className="gradient-text font-normal">für sich</span>
          </h2>
          <p className="mt-4 text-base text-slate-500 max-w-xl mx-auto">
            Wer heute nicht online sichtbar ist, verliert morgen Kunden. Diese Fakten zeigen, warum eine professionelle Webpräsenz unverzichtbar ist.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {stats.map((stat, i) => (
            <div
              key={stat.value}
              className={`bg-white/60 backdrop-blur-2xl border border-white/80 shadow-[0_8px_32px_rgba(0,0,0,0.04)] rounded-3xl p-8 transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_20px_40px_rgba(236,72,153,0.1)] hover:border-pink-200/50 ${
                inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: `${i * 80}ms` }}
              data-testid={`stat-card-${i}`}
            >
              <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-indigo-500/10 to-pink-500/10 flex items-center justify-center mb-5">
                <stat.icon size={22} className="text-purple-600" />
              </div>
              <div className="text-3xl font-bold gradient-text font-['Outfit'] mb-2">{stat.value}</div>
              <p className="text-sm text-slate-600 leading-relaxed">{stat.label}</p>
              <p className="mt-3 text-xs text-slate-400 italic">{stat.source}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
